import {NgModule} from "@angular/core";
import {CommonModule} from "@angular/common";
import {IntLabeledFieldBoxModule} from "../../boxes";
import {IntIconModule} from "../../int-icon";
import {IntMultiTagSelectComponent} from "./int-multi-tag-select.component";

import {IntInsertAfterViewInitModule} from "../../../directives";
import {IntPortalSlotModule} from "../../../modules/portal-slot";
import {IntDropdownAreaModule, IntDropdownListModule} from "../../dropdowns";
import {IntDropdownChevronModule} from "../../chanks";
import {IntDefaultCheckboxModule} from "../../int-default-checkbox/int-default-checkbox.module";
import {IntClosedTagModule} from "../../tags";

@NgModule({
  imports: [
    CommonModule,
    IntLabeledFieldBoxModule,
    IntIconModule,
    IntPortalSlotModule,
    IntInsertAfterViewInitModule,
    IntDropdownAreaModule,
    IntDropdownChevronModule,
    IntDropdownListModule,
    IntDefaultCheckboxModule,
    IntClosedTagModule
  ],
  declarations: [
    IntMultiTagSelectComponent
  ],
  exports: [
    IntMultiTagSelectComponent
  ]
})
export class IntMultiTagSelectModule {}
